/*=========================================
	++ common.js ++ Ver.1.6.1
	Last update 2020.9.10
==========================================*/
/*
* 2020  9/10 全体を一新
* 2019  5/ 7  *object-fit-images 追加
* 2018 11/20  *ブラウザ判定処理を一新
* 2018 10/25  *jQuery 3系 に対応
*/

'use strict';


//=====================================
//	Detecting Browser & Device Ver.1.4.2
//============================================

//++++++++++++ モバイル/タブレット/ブラウザ判定処理 ++++++++++++

//ブラウザ/デバイス 種別
var isMobile = false,
	isTablet = false,
	isRetina = false,
	isMobileTablet = false,
	isAndroid = false;

//モバイル　タブレット　判定
//https://w3g.jp/blog/js_browser_sniffing2015
var _ua = (function (u) {
	return {
		Tablet: (u.indexOf("windows") != -1 && u.indexOf("touch") != -1 && u.indexOf("tablet pc") == -1) ||
			u.indexOf("ipad") != -1 ||
			(u.indexOf("android") != -1 && u.indexOf("mobile") == -1) ||
			(u.indexOf("firefox") != -1 && u.indexOf("tablet") != -1) ||
			u.indexOf("kindle") != -1 ||
			u.indexOf("silk") != -1 ||
			u.indexOf("playbook") != -1,
		Mobile: (u.indexOf("windows") != -1 && u.indexOf("phone") != -1) ||
			u.indexOf("iphone") != -1 ||
			u.indexOf("ipod") != -1 ||
			(u.indexOf("android") != -1 && u.indexOf("mobile") != -1) ||
			(u.indexOf("firefox") != -1 && u.indexOf("mobile") != -1) ||
			u.indexOf("blackberry") != -1
	};
})(window.navigator.userAgent.toLowerCase());

//モバイル
if (_ua.Mobile) {
	isMobile = true;
	isMobileTablet = true;
}
//タブレット
if (_ua.Tablet) {
	isTablet = true;
	isMobileTablet = true;
}

//Retina Display 判定
if (window.devicePixelRatio > 1) {
	isRetina = true;
}

//Android 判定
if (/android[\/\s](\d+\.\d+)/.test(navigator.userAgent)) {
	isAndroid = true;
}




//============================================
//	デバイス　ブラウザ別の処理
//============================================

//++++++++++++ モバイル/タブレット クラス追加 ++++++++++++

$(function () {
	if (isMobile) {
		//HTMLにclass isMobileを追加
		$('html').addClass('isMobile');
		$('html').addClass('isMobileTablet');
	} else if (isTablet) {
		//HTMLにclass isTabletを追加
		$('html').addClass('isTablet');
		$('html').addClass('isMobileTablet');
	}
	//Retina Display isRetina クラス追加
	if (isRetina) {
		$('html').addClass('isRetina');
	}
});





//============================================
//	汎用スクリプト 
//============================================


//++++++ Copyright ++++++
// Copyright <span class="copyYear">&copy;</span>

$(function () {
	var date = new Date();
	var copyYear = date.getFullYear();
	copyYear = '&copy;' + copyYear;
	$('.copyYear').html(copyYear);
});




//============================================
//	アンカーリンク　スクロール
//============================================
$(function () {

	var TABLET_WIDTH = 768;
	//ウィンドウ幅
	var window_width = window.innerWidth;

	var nav_height = 80;
	if (window_width >= TABLET_WIDTH) {
		//PC
		nav_height = 160;
	}


	var target_parm = '';
	var match = location.search.match(/target=(.*?)(&|$)/);
	if (match) {
		target_parm = decodeURIComponent(match[1]);
		target_parm = '#' + target_parm;
	}
	if (target_parm.length) {
		setTimeout(function () {
			var targetOffset = $(target_parm).offset().top - nav_height;
			$('html,body').animate({
				scrollTop: targetOffset
			}, 800);

			setTimeout(function () {
				var targetOffset_next = $(target_parm).offset().top - nav_height;
				$('html,body').animate({
					scrollTop: targetOffset_next
				}, 100);

			}, 800);
			return false;
		}, 800);

	}

});


//============================================
//	ページ内　アンカーナビ　リンク
//============================================
$(function () {
	//ページ内アンカーは　囲みのDIVに class js-anc-navi 追加
	//  a タグは通常アンカー　<a href="#anc">リンク</a>

	//モバイル判定
	var TABLET_WIDTH = 768;
	//ウィンドウ幅
	var window_width = window.innerWidth;

	//++++ 固定ナビの高さ分ずらす設定  +++
	//モバイル
	var nav_height = 80;
	if (window_width >= TABLET_WIDTH) {
		//PC
		nav_height = 190;
	}

	//aタグクリックで発火
	$('.js-anc-navi a').on('click', function () {

		//a タグの href 取得
		var anc_href = $(this).attr('href');

		//初期ページローディングの遅れ対策
		setTimeout(function () {
			var targetOffset = $(anc_href).offset().top - nav_height;
			$('html,body').animate({
				scrollTop: targetOffset
			}, 800);

			//アンカーズレ　防止　もう一回実行
			setTimeout(function () {
				var targetOffset = $(anc_href).offset().top - nav_height;
				$('html,body').animate({
					scrollTop: targetOffset
				}, 100);
				return false;

			}, 800);

		}, 400);
		//リンクをたどらせない
		return false;
	});
});


//============================================
//	グローバルナビ　現在地
//============================================

$(function () {

	var $body = $('body');
	var my_path = location.pathname;

	// WP body class（詳細・アーカイブ共通）とURL両方で判定
	var is_home = $body.hasClass('Index');
	var is_nav1 = $body.hasClass('single-exhibition')    || $body.hasClass('post-type-archive-exhibition')    || my_path.match(/^\/exhibition\//i);
	var is_nav2 = $body.hasClass('single-event')         || $body.hasClass('post-type-archive-event')         || my_path.match(/^\/event\//i);
	var is_nav3 = $body.hasClass('single-project')       || $body.hasClass('post-type-archive-project')       || my_path.match(/^\/project\//i);
	var is_nav4 = my_path.match(/^\/moca\//i);
	var is_nav5 = my_path.match(/^\/store\//i);
	var is_nav6 = $body.hasClass('single-collection')    || $body.hasClass('post-type-archive-collection')    || my_path.match(/^\/collection\//i);
	var is_nav7 = $body.hasClass('single-communication') || $body.hasClass('post-type-archive-communication') || $body.hasClass('tax-communicationcat') || my_path.match(/^\/communication\//i);

	if (is_home) {
		$('.gnav00 a').addClass('hilight');
	} else if (is_nav1) {
		$('.gnav01 a').addClass('hilight');
	} else if (is_nav2) {
		$('.gnav02 a').addClass('hilight');
	} else if (is_nav3) {
		$('.gnav03 a').addClass('hilight');
	} else if (is_nav4) {
		$('.gnav04 a').addClass('hilight');
	} else if (is_nav5) {
		$('.gnav05 a').addClass('hilight');
	} else if (is_nav6) {
		$('.gnav06 a').addClass('hilight');
	} else if (is_nav7) {
		$('.gnav07 a').addClass('hilight');
	}

});


//+++++++ Footer PageTOP ++++++

$(function () {

	$('.scroll_top_btn').on('click', function () {
		$('html,body').animate({
			scrollTop: 0
		}, 800);
	});

	var TABLET_WIDTH = 768;
	//ウィンドウ幅
	var window_width = window.innerWidth;

	$(window).on('scroll', function () {

		var scroll_top = $(window).scrollTop();
		var hide_point = '';
		if (window_width >= TABLET_WIDTH) {
			hide_point = 600;
		} else {
			hide_point = 300;
		}

		if (hide_point < scroll_top) {
			$('.scroll_top_btn').fadeIn('fast');
		} else {
			$('.scroll_top_btn').fadeOut('fast');
		}
		//console.log(scroll_top)

	})


});



$(function () {
	$('.venobox').venobox({
		infinigall: true,
		numeratio: true,
	});
});




$(function () {
	$(".menubtn").click(function () {
		$(this).toggleClass('active');
		$('body').toggleClass('no-scroll');
		$("#spnav").toggleClass('panelactive');
	});

	$("#spnav a").click(function () {
		$(".menubtn").removeClass('active');
		$('body').removeClass('no-scroll');
		$("#spnav").removeClass('panelactive');
	});
})





//========= 検索 ================

$(function () {
	$('.search_tab_item').on('click', function () {
		const checkId = $(this).attr('id');

		$('.search_tab_item').removeClass('selected');
		$(this).addClass('selected');

		if ($('.search_cat_list').hasClass(checkId)) {
			// console.log('OK');
			$('.search_cat_list').removeClass('show');
			$(`.search_cat_list.${checkId}`).addClass('show');
		}
	});
});

// 商品検索モーダル
$(function () {
	$('.open-modal').on('click', function () {
		$('#modal_search').addClass('open');
		$('#modal_search .modal_bg').addClass('show');
		$("html,body").css("overflow", "hidden");
	});

	$('.close-modal').on('click', function () {
		$('#modal_search').removeClass('open');
		$('#modal_search .modal_bg').removeClass('show');
		$("html,body").removeAttr("style");
	});
});



// ボタン
$(function () {
	$('.btn--select').on('click', function () {
		$(this).toggleClass('selected');
		return false;
	});

	$('.btn--radio').on('click', function () {
		$('.btn--radio').removeClass('selected');
		$(this).addClass('selected');
		return false;
	});
});

//検索カテゴリ切り替え
$(function () {
	$('.js-type-toggle-btn').on('click', function () {

		$('.togle_SearchType').removeClass('toggle_show ');

		const target = $(this).data('target');

		$('.js-type-toggle-btn').removeClass('selected');
		$(this).addClass('selected');

		$('.togle_SearchType').fadeOut(0);
		$(target).fadeIn('slow');


	});
});



$(function () {
	var $grid = $('.grid'),
		emptyCells = [],
		i;

	for (i = 0; i < $grid.find('.cell').length; i++) {
		emptyCells.push($('<div>', {
			class: 'cell is-empty'
		}));
	}
	$grid.append(emptyCells);
});


$(function () {
	//swiper 768以下で起動
	var swiper;
	$(window).on('load resize', function () {
		var w = $(window).width();
		if (w <= 768) {
			if (swiper) {
				return;
			} else {
				swiper = new Swiper('.swiper-sp-collection', {
					loop: true,
					pagination: {
						el: '.swiper-pagination',
						clickable: true,
					},
				});
			}
		} else {
			if (swiper) {
				swiper.destroy();
				swiper = undefined;
			}
		}
	});
});



$(function () {
	$(".lang .jp a").click(function () {
		$('body').toggleClass('lang-jp');
		$('body').removeClass('lang-en');
	});

	$(".lang .en a").click(function () {
		$('body').removeClass('lang-jp');
		$('body').toggleClass('lang-en');
	});
})


$(function () {
	var navi = $('.fixed_nav');
	//スクロールしてページトップから100に達したらクラスを付与する
	$(window).on('load scroll', function () {
		if ($(this).scrollTop() > 200) {
			navi.addClass('fixed');
		} else {
			navi.removeClass('fixed');
		}
	});
});


// snav_cat クリックでカテゴリーリストを開く
$(function () {
	$('.snav_cat a').on('click', function (e) {
		e.preventDefault();
		$(this).addClass('active');
		$('.snav_sub').addClass('show');
	});
});


// スケジュールモーダル（exhibition_list ページで使用）
function openModal() {
	var modal = document.getElementById('schedule-modal');
	if (modal) modal.style.display = 'block';
}

function closeModal() {
	var modal = document.getElementById('schedule-modal');
	if (modal) modal.style.display = 'none';
}

var closeBtn = document.querySelector('.close');
if (closeBtn) {
	closeBtn.addEventListener('click', closeModal);
}